module.exports = __webpack_public_path__ + "static/vita_winfried_neun-8db6da4f50e471859b6851974610bc90.pdf";